import { render, staticRenderFns } from "./SoftStart.vue?vue&type=template&id=54037f38&scoped=true&"
import script from "./SoftStart.vue?vue&type=script&lang=js&"
export * from "./SoftStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54037f38",
  null
  
)

export default component.exports